<template>
  <div id="leftTree" class="provider_tree">
    <div class="leftTreeHead">
      <span class="leftTreeTitle">账户列表</span>
      <div class="leftTreeContent">
        <el-button
          @click="addSuppson"
          size="mini"
          type="primary"
          class="leftTreeAdd"
          v-if="addSupper"
          >添加</el-button
        >
        <el-button
          plain
          size="small"
          @click="daoru"
          type="primary"
          v-if="exportInfo"
        >
          导入
        </el-button>
        <!-- <el-checkbox v-model="checked" @change="changeBoxClick(checked)" class="leftTreeCheck">已策划人员</el-checkbox> -->
      </div>
    </div>
    <el-input
      v-model="suppLeftName"
      @input="searchKeyup"
      @keyup.enter.native="searchKeyup"
      class="leftSearch"
      placeholder="请输入关键字"
    >
      <i
        slot="suffix"
        v-if="suppLeftName !== ''"
        style="margin-right: 5px"
        class="el-icon-error"
        @click="searchClear"
      ></i>
      <i slot="suffix" class="el-icon-search" @click="searchKeyup"></i>
    </el-input>
    <ul
      class="infinite-list leftTable"
      v-infinite-scroll="loadNextData"
      infinite-scroll-disabled="false"
      infinite-scroll-immediate="false"
      style="overflow: auto"
    >
      <li
        v-for="(item, index) in leftAllData"
        class="infinite-list-item"
        :title="item.deptName"
        :class="{ activeColor: activeColor == item.deptId }"
        :key="index"
        @click="tableClick(item)"
      >
        <div class="name ellipsis">
          {{ item.deptName }}
        </div>
        <div class="operation">
          <i
            class="el-icon-edit"
            @click="editDept(item, index)"
            v-if="editSupper"
          ></i>
          <i
            class="el-icon-delete"
            @click="delDept(item, index)"
            v-if="deleSupper"
          ></i>
        </div>
      </li>
    </ul>
    <!-- 添加弹框 -->
    <el-dialog
      title="添加"
      :visible.sync="addDialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="treeForm"
        :model="treeForm"
        :rules="rules"
        label-width="120px"
        label-position="top"
      >
        <el-form-item label="请输入公司名称" prop="deptName">
          <el-input
            v-model="treeForm.deptName"
            placeholder="请输入公司名称"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="treeForm.remark"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="导入"
      v-dialogDrag
      custom-class="daoru-dialog"
      :visible.sync="professionDialogVisible4"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handlePofessionClose4"
    >
      <span>
        <div style="height: 32px; line-height: 32px" v-if="!fileList2.length">
          <p style="float: left">请下载导入模板，按格式修改后导入</p>
          <el-button
            style="float: right"
            size="small"
            type="primary"
            @click="down"
          >
            模板下载
          </el-button>
        </div>
        <div v-if="!fileList2.length">
          <div style="text-align: center; margin-top: 15px">
            <el-upload
              drag
              action="/"
              :before-upload="dataprogress1"
              :show-file-list="false"
              :http-request="httpRequest"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖拽至此区域，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                仅支持xls、xlsx格式，文件大小不超过5M
              </div>
            </el-upload>
          </div>
        </div>
        <div v-if="fileList2.length && isfail == 2">
          <div
            style="
              text-align: center;
              border: 1px dashed #d9d9d9;
              border-radius: 6px;
              width: 360px;
              margin: 0 auto;
              padding: 50px 0px;
            "
          >
            <img :src="xlssrc" alt="" style="vertical-align: text-bottom" />
            <p>
              <span>{{ fileList2[0].name }}</span>
            </p>
          </div>
          <div style="text-align: center; margin-top: 20px">
            <el-button
              size="small"
              type="primary"
              plain
              @click="newuplode"
              :loading="disabledone2"
            >
              重新上传
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click="suredaoru"
              :loading="disabledone2"
            >
              确认导入
            </el-button>
          </div>
        </div>
        <div v-if="fileList2.length && isfail == 1">
          <div style="text-align: center">
            <img :src="dangersrc" alt="" />
          </div>
          <p style="text-align: center; margin-top: 20px; font-size: 16px">
            <span style="color: #409eff">{{ successtotals }}</span
            >条导入成功， <span style="color: #e6a23c">{{ dangertotals }}</span
            >条导入失败
            <span
              @click="getList(dangerlist)"
              style="color: #409eff; cursor: pointer"
              >下载失败列表</span
            >
          </p>
          <div style="text-align: center; margin-top: 20px">
            <el-button size="small" type="primary" plain @click="newuplode">
              重新导入
            </el-button>
          </div>
        </div>
        <div v-if="fileList2.length && isfail == 0">
          <div style="text-align: center">
            <img :src="successsrc" alt="" />
          </div>
          <p style="text-align: center; margin-top: 20px; font-size: 16px">
            <span style="color: #409eff">{{ successtotals }}</span
            >条导入成功
          </p>
          <div style="text-align: center; margin-top: 20px">
            <el-button size="small" type="primary" plain @click="newuplode">
              继续导入
            </el-button>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import request from "@/xgzdService/supperson-service";
import { checkPermission, disablePrompt } from "@/utils/routeAuth";
import { downloadTemplate, getToken } from "@/utils";
import systemPersonService from "@/xgzdService/enterprisePerson-service";
export default {
  data() {
    return {
      checked: false,
      suppLeftName: "",
      leftAllData: [],
      activeColor: "",
      addDialogVisible: false,
      treeForm: {
        deptName: "",
        remark: "",
      },
      venderId: "",
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
      },
      exportInfo: checkPermission("supperManage:exportPerson"),
      addSupper: checkPermission("supperManage:addSupper"),
      editSupper: checkPermission("supperManage:editSupper"),
      deleSupper: checkPermission("supperManage:deleSupper"),
      addPerson: checkPermission("supperManage:addPerson"),
      delePerson: checkPermission("supperManage:delePerson"),
      downPerson: checkPermission("supperManage:downPerson"),
      exportPerson: checkPermission("supperManage:exportPerson"),
      professionDialogVisible4: false,
      fileList2: [], //上传的文件      有文件 就展示文件列表页面 没文件就展示选择文件的页面
      disabledone2: false, //正在调用上传文件的接口
      dangerlist: [], // 失败的文件
      successtotals: 0, //成功的条数
      dangertotals: 0, //失败的条数
      isfail: 2, // 1 展示失败 0展示成功 2展示文件列表页
      successsrc: require("@/CommonDP/assets/addpersonInfo/导入成功.png"),
      dangersrc: require("@/CommonDP/assets/addpersonInfo/导入失败.png"),
      xlssrc: require("@/CommonDP/assets/addpersonInfo/图表.png"),
      exportLoading: false,
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
  },

  mounted() {
    this.init();
  },

  methods: {
    daoru() {
      const a = disablePrompt();
      if (a) {
        this.professionDialogVisible4 = true;
        this.disabledone2 = false;
        this.fileList2 = [];
        this.dangerlist = [];
        this.isfail = 2;
      }
    },
    newuplode() {
      this.disabledone2 = false;
      this.fileList2 = [];
      this.dangerlist = [];
      this.isfail = 2;
    },
    async getList(failList) {
      systemPersonService
        .drawingDrawingQuesExport2(failList)
        .then((response) => {
          const fileName = "导入失败列表.xlsx";
          if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
            // var blob = response
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
    },
    down() {
      let downzipurl = downloadTemplate();
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = downzipurl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    //上传1
    dataprogress1(file) {
      console.log(file, "1");
      var tt = file.name;
      var ttt = tt.split(".");
      var ttl = ttt.length;
      const isXLSX = ttt[ttl - 1] === "xlsx";
      const isXLS = ttt[ttl - 1] === "xls";
      const isPG = isXLSX || isXLS;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isPG) {
        this.$message({
          showClose: true,
          message: "上传文件只能是 .xls .xlsx 格式!",
          type: "warning",
        });
      } else if (!isLt2M) {
        this.$message({
          showClose: true,
          message: "上传文件大小不能超过 5M!",
          type: "warning",
        });
      }
      return isPG && isLt2M;
    },
    async httpRequest({ file }) {
      this.fileList2.push(file);
    },
    // 关闭驳回弹框
    handlePofessionClose4() {
      this.professionDialogVisible4 = false;
    },
    randomWord(randomFlag, min, max) {
      var str = "",
        range = min,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
        ];
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },

    async init(val) {
      let params = {
        enterpriseId: this.enterpriseId,
        deptName: this.suppLeftName || val,
      };
      let res = await request.getOrgTree(params);
      this.leftAllData = res.data ? JSON.parse(JSON.stringify(res.data)) : [];
      this.leftAllData.unshift({
        deptId: '',
        venderId: '',
        deptName: '全部'
      })
      this.$emit("getLeftAllData", res.data || []);

      if (this.leftAllData[0]) {
        const { deptId, venderId } = this.leftAllData[0];
        this.venderId = deptId || venderId;
        this.activeColor = this.venderId;
        this.$emit("getLeftClickData", [{ venderId: this.venderId }]);
      }
    },

    async addSuppson() {
      this.addDialogVisible = true;
    },

    changeBoxClick(val) {},
    //左侧搜索框回车事件
    searchKeyup() {
      this.pageNo = 1;
      let val = this.searchKeyup;
      this.init(val);
    },
    //左侧搜索框清空事件
    searchClear() {
      this.clickType = true;
      this.suppLeftName = "";
      this.pageNo = 1;
      this.leftAllData = [];
      let val = this.suppLeftName;
      this.init(val);
    },
    loadNextData() {
      let num = 1;
      if (this.totalPage > num) {
        this.pageNo++;
        num++;
        if (this.changeType == true) {
          let val = this.changeType;
          this.changeBoxClick(val);
        } else {
          this.getLeftData();
        }
      }
    },
    //左侧列表点击事件
    tableClick(row) {
      // this.suppLeftName = row.lifnrName
      this.clickType = true;
      this.tablePageNo = 1;
      this.suppRighSearch = "";
      this.venderName = row.deptName;
      this.activeColor = row.deptId;
      this.venderId = row.deptId || row.venderId;
      let params = {
        venderId: this.venderId,
        pageNo: 1,
        pageSize: 10,
      };
      let arr = [];
      arr.push(params);
      this.$emit("getLeftClickData", arr);
      // request.getRawVenderUsers(params).then(res => {
      //   this.suppTableData = res.data;
      //   this.tableTotalCount = res.totalCount;
      // });
    },

    /**
     * 编辑供方公司
     * @param item 当前编辑部门对应得对象
     * @param index 索引
     */
    editDept(item, index) {
      this.$prompt("", "供方名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: item.deptName,
        inputValidator: function (val) {
          if (!val) {
            return "名称不能为空";
          }

          if (!val.trim()) {
            return "名称不能为空";
          }

          if (val.length > 30) {
            return "供方名称不能超过30个字符";
          }
        },
      }).then(async ({ value }) => {
        const { deptId } = item;
        const deptName = value;
        const remark = "";
        const res = await request.editSupplier({ deptId, deptName, remark });
        if (res.result === "0") {
          this.$message.success("修改成功");
          item.deptName = value;
        }
      });
    },

    /**
     * 删除供方公司
     * @param item 当前编辑部门对应得对象
     * @param index 索引
     */
    delDept(item, index) {
      this.$confirm("此操作将删除该供方公司, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { deptId } = item;
          const res = await request.delSupplier(deptId);
          if (res.result === "0") {
            this.$message.success("删除成功");
            await this.init();
          }
        })
        .catch(() => {});
    },

    //关闭供方弹框
    handleClose() {
      this.addDialogVisible = false;
    },
    //添加供方
    addBtn() {
      //生成随机数
      // let random = this.randomWord(true, 32, 32);
      this.$confirm("是否添加?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          // deptCode: random,
          deptName: this.treeForm.deptName,
          enterpriseId: this.enterpriseId,
          // parentDeptId: "9999999999999998",
          remark: this.treeForm.remark,
        };
        await request.getorgaddDept(params);
        this.$message.success("添加成功!");
        this.addDialogVisible = false;
        this.init();
      });
    },
    suredaoru() {
      this.disabledone2 = true;
      const data = new FormData();
      data.append("file", this.fileList2[0]);
      data.append("enterpriseId", this.enterpriseId);
      systemPersonService
        .enterpriseimport(data)
        .then((res1) => {
          if (res1.result == "0") {
            this.disabledone2 = false;
            if (res1.data.failList.length) {
              // 导入失败
              this.successtotals = res1.data.successNum; //成功条数
              this.dangertotals = res1.data.failList.length; //失败条数
              this.dangerlist = res1.data.failList;
              this.isfail = 1;
            } else {
              // 导入成功
              this.dangerlist = [];
              this.successtotals = res1.data.successNum;
              this.isfail = 0;
            }
            this.$emit('exportSuccess')
          }
        })
        .catch(() => {
          this.disabledone2 = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.provider_tree {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  .leftTable {
    padding-top: 20px;
    li {
      padding: 0 30px;
      font-size: 14px;
      height: 36px;
      line-height: 36px;
      color: #000000;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        width: 85%;
      }
      .operation {
        width: 10%;
        display: none;
        i {
          font-size: 16px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    li:hover .operation {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .activeColor {
      background: rgba(38, 95, 206, 0.09);
    }
  }
}
.leftTreeHead {
  display: flex;
  align-items: center;
  padding: 0 3px;
  box-sizing: border-box;
  flex-flow: column nowrap;

  .leftTreeTitle {
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    border-left: 2px solid rgb(55, 81, 228);
    padding: 0px 10px;
  }
  .leftTreeContent {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 10px 0px;
  }
  .leftTreeAdd {
    font-size: 14px;
    cursor: pointer;
  }
  .leftTreeCheck {
    margin-left: 10px;
  }
}
.leftSearch {
  height: 32px;
  line-height: 32px;
  flex-shrink: 0;
  /deep/ .el-input__inner {
    height: 100%;
  }
}
/deep/ .el-input__suffix {
  height: 32px;
  line-height: 32px;
  right: 10px;
}
</style>
